import ButtonV1 from "lib/ButtonV1";
import React, { useEffect, useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import "./index.scss";
import Toast from "components/ToastComponent";

const FilterComponent = ({
  name,
  trigger,
  triggerWhen,
  placement,
  children,
  show,
  delay,
  handleItemClick,
  fullBodyPresent,
  selectedData, // don't remove using this inside eval
  handleToggle,
}) => {
  const customEval = (condition) => {
    if (!condition) return true;
    else return eval(condition);
  };
  const [toastMessage, setToastMessage] = useState(false);
  const [showPopover, setShowPopover] = useState(undefined);
  const [itemsLength, setItemsLength] = useState(0);

  useEffect(() => {
    if (!fullBodyPresent) {
      let items_length = 0;
      for (const item of children) {
        if (customEval(item.show)) {
          items_length++;
        }
      }
      setItemsLength(items_length);
    } else setItemsLength(1);
  }, [children]);

  const onItemClick = (item) => {
    if (item.id?.includes("send_reminder")) {
      let reminderValidtaion = item?.id.split("-");
      if(reminderValidtaion.length == 1){
        setToastMessage(true);
        setTimeout(() => {
          setToastMessage(null);
        }, 3000);
      }
    }
    setShowPopover(false);
    setTimeout(() => {
      setShowPopover(undefined);
    }, 1);
    handleItemClick(item?.id, item);
    handleToggle && handleToggle(false);
  };

  const popover = (children) => (
    <Popover id="popover-basic" bsPrefix="popover-basic">
      {fullBodyPresent ? (
        children
      ) : (
        <ul className="option_list shadow-sm rounded-0 border-0 px-1 mb-2 mx-0 bg-white ">
          {children?.map(
            (ele, i) =>
              customEval(ele?.show) && (
                <ButtonV1
                  key={i}
                  className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey"
                  onClick={() => onItemClick(ele)}
                  disabled={ele?.disabled ? eval(ele?.disabled) : false}
                  label={ele?.label}
                  variant="light"
                  {...ele}
                />
              )
          )}
        </ul>
      )}
    </Popover>
  );

  if (!itemsLength) {
    return <></>;
  }
  return (
    <>
      {toastMessage && <Toast type="success" message="Reminder sent successfully" autoClose={3000} />}
      <OverlayTrigger
        trigger={triggerWhen ? triggerWhen : "click"}
        placement={placement ? placement : "bottom"}
        overlay={popover(children)}
        delay={{ hide: delay }}
        rootClose
        containerPadding={0}
        flip={true}
        onToggle={handleToggle && handleToggle}
        show={showPopover}
        onHide={() => handleToggle && handleToggle(false)}
      >
        {trigger}
      </OverlayTrigger> 
    </>
  );
};

export default React.memo(FilterComponent);
